var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormbodyBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#0D1E9F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#0548b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#0548b5",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#0548b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#0135ab",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#0d1e9f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#0135ab",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#0548b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#0548b5",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#0135ab",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#0548b5",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#0135ab",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#0d1e9f",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 287C-30.4 285 -60.8 283 -89 273.9C-117.2 264.8 -143.1 248.6 -168.1 231.4C-193.1 214.2 -217.3 196 -237.9 172.8C-258.4 149.7 -275.5 121.5 -282.9 91.9C-290.3 62.3 -288.2 31.1 -286 0L0 0Z",
    fill: "#062aa5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 191.3C-20.3 190 -40.6 188.7 -59.3 182.6C-78.1 176.5 -95.4 165.7 -112.1 154.3C-128.8 142.8 -144.8 130.6 -158.6 115.2C-172.3 99.8 -183.6 81 -188.6 61.3C-193.6 41.5 -192.1 20.8 -190.7 0L0 0Z",
    fill: "#013fb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 95.7C-10.1 95 -20.3 94.3 -29.7 91.3C-39.1 88.3 -47.7 82.9 -56 77.1C-64.4 71.4 -72.4 65.3 -79.3 57.6C-86.1 49.9 -91.8 40.5 -94.3 30.6C-96.8 20.8 -96.1 10.4 -95.3 0L0 0Z",
    fill: "#0548b5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -282C31.7 -286.7 63.4 -291.3 91.9 -282.9C120.4 -274.4 145.7 -252.9 168.7 -232.2C191.7 -211.5 212.4 -191.7 232.2 -168.7C252 -145.7 270.8 -119.5 279.6 -90.9C288.4 -62.2 287.2 -31.1 286 0L0 0Z",
    fill: "#062aa5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -188C21.1 -191.1 42.3 -194.2 61.3 -188.6C80.3 -183 97.1 -168.6 112.5 -154.8C127.8 -141 141.6 -127.8 154.8 -112.5C168 -97.1 180.5 -79.7 186.4 -60.6C192.3 -41.5 191.5 -20.7 190.7 0L0 0Z",
    fill: "#013fb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -94C10.6 -95.6 21.1 -97.1 30.6 -94.3C40.1 -91.5 48.6 -84.3 56.2 -77.4C63.9 -70.5 70.8 -63.9 77.4 -56.2C84 -48.6 90.3 -39.8 93.2 -30.3C96.1 -20.7 95.7 -10.4 95.3 0L0 0Z",
    fill: "#0548b5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormbodyBackground);
export default __webpack_public_path__ + "static/media/formbody-background.875710fd0f07422158579f096a30dca4.svg";
export { ForwardRef as ReactComponent };